/**
 * City-local wall-clock time as `HHMM` (`"0000"`–`"2359"`).
 * Used for walk-in claim-window filtering; host sets from the city's timezone.
 */
export type WalkInTime = string;

/** Default {@link WalkInModel.time} before the host syncs city-local clock. */
export const DEFAULT_WALK_IN_TIME: WalkInTime = "0000";

const WALK_IN_TIME_PATTERN = /^([01]\d|2[0-3])[0-5]\d$/;

export const isValidWalkInTime = (time: string): time is WalkInTime =>
  WALK_IN_TIME_PATTERN.test(time);

/**
 * Minutes past midnight for a valid `HHMM` string, or `null` if invalid.
 */
export const walkInTimeToMinutes = (time: string): number | null => {
  if (!isValidWalkInTime(time)) {
    return null;
  }
  const hours = Number(time.slice(0, 2));
  const minutes = Number(time.slice(2, 4));
  return hours * 60 + minutes;
};
